import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Bannière d'accueil : une seule section centrale avec titre et CTA
 * sur fond d'image (desktop: banner-bg.png, mobile: banner-bg-mobile.png).
 */
function BannerHomepage() {
  return (
    <section className="section-banner-homepage" aria-label="Bannière d'accueil">
      <div className="banner-homepage-content">
        <h2 className="banner-homepage-title">
          <span className="banner-homepage-title-line1">N'économisez pas votre</span>
          <span className="banner-homepage-title-line2"> bonheur</span>
        </h2>
        <div className="banner-homepage-cta">
          <NavLink className="btn banner-homepage-btn" to="/produits">
            DÉCOUVREZ NOS PRODUITS
          </NavLink>
        </div>
      </div>
    </section>
  );
}

export default BannerHomepage;
